import { Injectable } from '@angular/core';
import { Http, RequestOptionsArgs, Headers } from '@angular/http';
import { environment } from "../../environments/environment";

declare var AWS: any;
declare var S3: any;

@Injectable()
export class FileUploadService {

    constructor(private _http: Http) { }

    upload(file, filePath, isPublic): Promise<any> {
        
      return new Promise((resolve,reject) => {
        AWS.config.update({    		  
    		  region: environment.region
    		});

        var logins = {}
        logins['cognito-idp.' + environment.region + '.amazonaws.com/' + environment.userPoolId] = localStorage.getItem('idToken');
        // Add the User's Id Token to the Cognito credentials login map.
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: environment.identityPoolId,
        Logins: logins
        });   
    		var S3 = new AWS.S3({params: {Bucket: environment.s3Bucket.bucketName }});    
        // Specify the S3 upload parameters
        let params = {
          Key: filePath,
          ContentType: file.type,
          Body: file,
          // ACL: 'public-read'
        };

        if(isPublic) {
          params['ACL'] = 'public-read';
        }
  
        // Upload the file
        S3.upload(params, function(err, data) {
          if (err) {
            reject(err);  
          } else {                    
            resolve(data);
          }
        });        
      });
      
    }
}


// WEBPACK FOOTER //
// ./src/app/services/file-upload.service.ts